import axios from "axios";
import notify from "devextreme/ui/notify";
import vue from "./../main";
import qs from 'qs';

class RequestHandler {
    constructor() {
        this.apiUrl = `/api/`;
        if (RequestHandler.instance) {
            return RequestHandler.instance;
        }
        RequestHandler.instance = this;
        return this;
    }
    fullUrl(path, id = null) {
        path = path.replace(/^\/+|\/+$/g, ""); // Leszedi a felesleges /-eket a path-ből
        return `${this.apiUrl}${path}${id ? `/${id}` : ""}`; // Ha van id paraméter, akkor /id-vel kiegészíti
    }
    async get(path, id = null) {
        try {
            const response = await axios.get(this.fullUrl(path, id));
            return response.data;
        }
        catch (error) {
            await this.error(error);
            return null;
        }
    }
    async getWithParams(path, loadOptions) {
        try {
            const response = await axios.get(this.apiUrl + path, { params: loadOptions });
            return response.data;
        }
        catch (error) {
            await this.error(error);
            return null;
        }
    }
    async getById(path, id) {
        try {
            const response = await axios.get(this.fullUrl(path, id));
            return response.data;
        }
        catch (error) {
            await this.error(error);
            return null;
        }
    }
    async post(path, data) {
        try {
            const response = await axios.post(this.fullUrl(path), data);
            return response.data;
        }
        catch (error) {
            await this.error(error);
            return null;
        }
    }
    async put(path, data) {
        // TODO put-nál benne van az id a data-ban
        try {
            const response = await axios.put(this.fullUrl(path), qs.stringify(data), {
                headers: {
                    "content-zype": "application/x-www-form-urlencoded"
                }
            });
            return response.data;
        }
        catch (error) {
            await this.error(error);
            return null;
        }
    }
    async delete(path, id) {
        try {
            const response = await axios.delete(this.fullUrl(path, id));
            return response.data;
        }
        catch (error) {
            await this.error(error);
            return null;
        }
    }
    async import(path, data) {
        try {
            const response = await axios.post(
                this.fullUrl(path, 'import'),
                data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
            });
            return response.data;
        }
        catch (error) {
            await this.error(error);
            return null;
        }
    }
    async download(path, data) {
        const response = await axios.get(
            this.fullUrl(path, 'download'), {
                params: data,
                responseType: 'blob'
            }).catch(async function (e) {
                let errorMessage = await new Response(e.response.data).text();
                //errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');

                notify({
                    message: vue.$te("error." + errorMessage)
                        ? vue.$t("error." + errorMessage)
                        : errorMessage,
                    position: {
                        at: "top",
                        offset: "0 40"
                    }
                }, "error", 5000);
            });
        return response.data;
    }
    async generateReport(path, data) {
        const response = await axios.post(
            this.fullUrl(path, 'generateReport'),
            data,
            {
                responseType: 'blob'
            }).catch(async function(e) {
                let errorMessage = await new Response(e.response.data).text();
                //errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');

                notify({
                    message: vue.$te("error." + errorMessage)
                        ? vue.$t("error." + errorMessage)
                        : errorMessage,
                    position: {
                        at: "top",
                        offset: "0 40"
                    }
                }, "error", 5000);
            });
        return response.data;
    }
    async error(error) {
        const foobar = JSON.parse(JSON.stringify(error));
        console.log(foobar);
        console.log(error.response);
        let errorMessage = null;
        if (error.isAxiosError) {
            if (typeof error.response.data === "string") {
                errorMessage = error.response.data;
            }
            else {
                errorMessage = error.message;
            }
        }
        else {
            errorMessage = error.response.data.error_description;
        }
        notify({
            message: vue.$te("error." + errorMessage)
                ? vue.$t("error." + errorMessage)
                : errorMessage,
            position: {
                at: "top",
                offset: "0 40"
            }
        }, "error", 5000);
    }
}
const instance = new RequestHandler();
export default instance;